import axios from 'axios';

const Backend = {
  init(services, backendOptions, i18nextOptions) {
    console.log('backend init', services, backendOptions, i18nextOptions);

    this.options = backendOptions;
  },
  read(language, namespace, callbackfn) {
    console.log('backend', language, namespace, callbackfn);
    if (this.loadedLanguages[language]) {
      const l = this.loadedLanguages[language];
      if (l.pendingCallbacks.length > 0) {
        console.log(`language ${language} pending in cache`);
        l.pendingCallbacks.push({ callback: callbackfn, namespace });
        return;
      }
      console.log(`language ${language} in cache`);
      if (l.data[namespace]) {
        callbackfn(null, l.data[namespace]);
      } else {
        callbackfn(true, null);
      }
      return;
    }

    const cachedHash = localStorage.getItem(`lang_${language}_hash`);

    let params = {};
    if (cachedHash && localStorage.getItem(`lang_${language}_data`)) {
      params.hash = cachedHash;
    }

    this.loadedLanguages[language] = { pendingCallbacks: [{ callback: callbackfn, namespace }] };
    axios.get(`${this.getURL()}/languages/${this.options.type}/${language}`, { params })
      .then(d => {
        d = d.data;
        console.log('got language', language, d);

        let res;
        if (d.result === 'notchanged') {
          console.log('load language from localStorage cache');
          res = JSON.parse(localStorage.getItem(`lang_${language}_data`));
        } else {
          const matches = /^\s*export\s+default\s*(\{.*\})\s*;\s*$/s.exec(d.file);
          console.log('data', matches);
          let fileData = d.file;
          if (matches) {
            fileData = matches[1];
          }
          res = eval('(' + fileData + ')'); // eslint-disable-line no-eval
          console.log('parsed language', res);

          localStorage.setItem(`lang_${language}_hash`, d.hash);
          localStorage.setItem(`lang_${language}_data`, JSON.stringify(res));
        }
        let l = this.loadedLanguages[language];
        l.data = res;
        l.pendingCallbacks.forEach(p => {
          p.callback(null, res[namespace]);
        });
        l.pendingCallbacks = undefined;
      })
      .catch(e => {
        console.log('error getting language', language);
        let l = this.loadedLanguages[language];
        l.data = { };
        l.pendingCallbacks.forEach(p => {
          p.callback(true, null);
        });
        l.pendingCallbacks = undefined;
      });
  },
  getURL() {
    const params = (new URL(document.location)).searchParams;
    const serveraddr = params.get('server') || localStorage.getItem('lastcredsserver') || window.location.hostname;
    const serverport = params.get('port') || localStorage.getItem('lastcredsport') || window.location.port;
    const serverprotocol = params.get('protocol') || localStorage.getItem('lastcredsprotocol') ||
      window.location.protocol;
    return `${serverprotocol}//${serveraddr}:${serverport}/rest/login`;
  },
  options: {},
  loadedLanguages: {},
  type: 'backend'
};

export default Backend;
